export class PdfValues {
    constructor(preparedFor = "", preparedBy = "", firm = "", illustrationDate = "", amount = "", gender = "", age = "", state = "", calculatedBy, singlePremiumAmount = "", guaranteedDeathBenefit = "", chronicIllnessBenefit = "", terminalConditionBenefit = "") {
        this.preparedFor = preparedFor;
        this.preparedBy = preparedBy;
        this.firm = firm;
        this.illustrationDate = illustrationDate;
        this.amount = amount;
        this.gender = gender;
        this.age = age;
        this.state = state;
        this.calculatedBy = calculatedBy;
        this.singlePremiumAmount = singlePremiumAmount;
        this.guaranteedDeathBenefit = guaranteedDeathBenefit;
        this.chronicIllnessBenefit = chronicIllnessBenefit;
        this.terminalConditionBenefit = terminalConditionBenefit;
    }
}
